setTimeout(() => {
  if (window.__openCartHookInit) return;
  window.__openCartHookInit = true;

  const openCartUI = async () => {
    try {
      // 1) Refresh cart-related sections so the drawer has current items
      await refreshCartSections();
    } catch (e) {
      console.warn("cart sections refresh failed:", e);
    }

    // 2) Open your theme’s off-canvas cart
    const offcanvas = document.getElementById("offcanvas_mini_cart");
    if (offcanvas) {
      offcanvas.classList.add("active");
      offcanvas.style.visibility = "visible";
      offcanvas.style.opacity = "1";
      offcanvas.style.transform = "translateX(0)";
      document.body.classList.add("added__overlay");
      return;
    }

    // 3) Fallbacks (if you happen to also have Dawn bits around)
    setTimeout(() => {
      const cartNotification = document.querySelector("cart-notification");
      if (cartNotification) {
        fetch("/?sections=cart-notification,cart-notification-count")
          .then((r) => r.json())
          .then((sections) => {
            if (typeof cartNotification.renderContents === "function") {
              cartNotification.renderContents({ sections });
            } else if (typeof cartNotification.open === "function") {
              cartNotification.open();
            }
          })
          .catch((err) =>
            console.warn("Cart notification refresh failed:", err),
          );
      }
    }, 500);

    // 4) Absolute last resort
    //   location.href = "/cart";
  };

  // Deduper so we don't open twice if multiple network calls fire
  let lastOpenTs = 0;
  const triggerOpenOnce = () => {
    const now = Date.now();
    if (now - lastOpenTs < 500) return; // ignore bursts
    lastOpenTs = now;
    queueMicrotask(openCartUI);
  };

  // --- Hook fetch (covers many themes/apps) ---
  const _fetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === "string" ? input : (input && input.url) || "";
    const method = (
      init?.method ||
      (typeof input !== "string" ? input?.method : "") ||
      "GET"
    ).toUpperCase();
    const isCartMutation =
      /\/cart\/(add(\.js)?|change(\.js)?|update(\.js)?)$/i.test(url) &&
      method !== "GET";

    if (isCartMutation) console.log("fetch cart mutation ->", method, url);

    return _fetch.apply(this, arguments).then((res) => {
      try {
        if (isCartMutation && res.ok) triggerOpenOnce();
      } catch (e) {
        console.warn("fetch hook error:", e);
      }
      return res;
    });
  };

  // --- Hook XHR (covers Searchanise / older apps) ---
  (function () {
    const XHR = window.XMLHttpRequest;
    if (!XHR) return;

    const _open = XHR.prototype.open;
    const _send = XHR.prototype.send;

    XHR.prototype.open = function (method, url) {
      this.__atc_method = (method || "GET").toUpperCase();
      this.__atc_url =
        typeof url === "string" ? url : (url && url.toString()) || "";
      return _open.apply(this, arguments);
    };

    XHR.prototype.send = function () {
      try {
        this.addEventListener("load", () => {
          const url = this.__atc_url || "";
          const method = this.__atc_method || "GET";
          const isCartMutation =
            /\/cart\/(add(\.js)?|change(\.js)?|update(\.js)?)$/i.test(url) &&
            method !== "GET";

          if (isCartMutation) {
            if (this.status >= 200 && this.status < 300) {
              triggerOpenOnce();
            }
          }
        });
      } catch (e) {
        console.warn("xhr hook setup failed:", e);
      }
      return _send.apply(this, arguments);
    };
  })();

  // Optional: capture-phase click (diagnostics only)
  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target.closest(".snize-add-to-cart-button");
      if (btn) {
        openCartUI();
      }
    },
    true,
  );

  console.debug("[open-cart-after-add] init");
}, 500);

(function () {
  function cameFromBFCache(evt) {
    if (evt && evt.persisted) return true; // Safari/Firefox
    var nav =
      performance.getEntriesByType &&
      performance.getEntriesByType("navigation")[0];
    return nav && nav.type === "back_forward"; // Chrome/Edge
  }

  window.addEventListener("pageshow", function (evt) {
    if (cameFromBFCache(evt)) {
      fetch("/cart.js")
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          document
            .querySelectorAll("#cart-notification-count")
            .forEach(function (el) {
              el.textContent = cart.item_count;
            });
        })
        .catch(function (e) {
          console.warn("Cart sync failed:", e);
        });
    }
  });
})();
